import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Shield, User, ChevronRight, Info } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
const Login = () => {
  const [loginType, setLoginType] = useState<'user' | 'guardian' | null>(null);
  const navigate = useNavigate();
  const handleLogin = (type: 'user' | 'guardian') => {
    setLoginType(type);
    // In a real app, this would authenticate with UAE Pass
    // For now, we'll navigate to the appropriate dashboard
    setTimeout(() => {
      if (type === 'guardian') {
        navigate('/guardian-dashboard');
      } else {
        navigate('/dashboard');
      }
    }, 1500);
  };
  return <div className="min-h-screen flex flex-col bg-gradient-to-b from-amber-50 to-amber-100" data-id="element-640">
      <Header data-id="element-641" />
      <main className="flex-grow py-16 px-4" data-id="element-642">
        <div className="max-w-4xl mx-auto" data-id="element-643">
          <div className="text-center mb-12" data-id="element-644">
            <h1 className="text-4xl font-bold text-emerald-900 mb-4" data-id="element-645">
              Welcome to EmiratiMatch
            </h1>
            <p className="text-xl text-gray-700" data-id="element-646">
              Choose your login type to continue
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-647">
            {/* User Login */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300" data-id="element-648">
              <div className="bg-gradient-to-r from-emerald-700 to-teal-700 p-6 text-white" data-id="element-649">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4" data-id="element-650">
                  <User className="h-8 w-8" data-id="element-651" />
                </div>
                <h2 className="text-2xl font-bold mb-2" data-id="element-652">User Login</h2>
                <p className="text-emerald-100" data-id="element-653">
                  For individuals seeking marriage
                </p>
              </div>
              <div className="p-6" data-id="element-654">
                <div className="space-y-4 mb-6" data-id="element-655">
                  <div className="flex items-start" data-id="element-656">
                    <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" data-id="element-657">
                      <span className="text-emerald-700 text-sm font-bold" data-id="element-658">
                        ✓
                      </span>
                    </div>
                    <p className="text-gray-700" data-id="element-659">View your weekly match</p>
                  </div>
                  <div className="flex items-start" data-id="element-660">
                    <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" data-id="element-661">
                      <span className="text-emerald-700 text-sm font-bold" data-id="element-662">
                        ✓
                      </span>
                    </div>
                    <p className="text-gray-700" data-id="element-663">
                      Chat with matches (with guardian oversight)
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-664">
                    <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" data-id="element-665">
                      <span className="text-emerald-700 text-sm font-bold" data-id="element-666">
                        ✓
                      </span>
                    </div>
                    <p className="text-gray-700" data-id="element-667">Accept or decline matches</p>
                  </div>
                </div>
                <button onClick={() => handleLogin('user')} className="w-full bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center" data-id="element-668">
                  Login as User
                  <ChevronRight className="ml-2 h-5 w-5" data-id="element-669" />
                </button>
              </div>
            </div>
            {/* Guardian Login */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300" data-id="element-670">
              <div className="bg-gradient-to-r from-amber-600 to-amber-700 p-6 text-white" data-id="element-671">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4" data-id="element-672">
                  <Shield className="h-8 w-8" data-id="element-673" />
                </div>
                <h2 className="text-2xl font-bold mb-2" data-id="element-674">Guardian Login</h2>
                <p className="text-amber-100" data-id="element-675">
                  For parents overseeing their child's journey
                </p>
              </div>
              <div className="p-6" data-id="element-676">
                <div className="space-y-4 mb-6" data-id="element-677">
                  <div className="flex items-start" data-id="element-678">
                    <div className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" data-id="element-679">
                      <span className="text-amber-700 text-sm font-bold" data-id="element-680">
                        ✓
                      </span>
                    </div>
                    <p className="text-gray-700" data-id="element-681">
                      Monitor your child's matches and conversations
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-682">
                    <div className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" data-id="element-683">
                      <span className="text-amber-700 text-sm font-bold" data-id="element-684">
                        ✓
                      </span>
                    </div>
                    <p className="text-gray-700" data-id="element-685">
                      Chat directly with other guardians
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-686">
                    <div className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" data-id="element-687">
                      <span className="text-amber-700 text-sm font-bold" data-id="element-688">
                        ✓
                      </span>
                    </div>
                    <p className="text-gray-700" data-id="element-689">
                      Accept or decline matches on behalf of your child
                    </p>
                  </div>
                </div>
                <button onClick={() => handleLogin('guardian')} className="w-full bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center" data-id="element-690">
                  Login as Guardian
                  <ChevronRight className="ml-2 h-5 w-5" data-id="element-691" />
                </button>
              </div>
            </div>
          </div>
          {/* Info Box */}
          <div className="bg-white rounded-xl shadow-md p-6" data-id="element-692">
            <div className="flex items-start" data-id="element-693">
              <Info className="h-6 w-6 text-emerald-700 mr-3 mt-1 flex-shrink-0" data-id="element-694" />
              <div data-id="element-695">
                <h3 className="font-bold text-emerald-900 mb-2" data-id="element-696">
                  New to EmiratiMatch?
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-697">
                  Both users and guardians need to complete separate
                  verification processes. If you haven't registered yet, please
                  complete the registration process first.
                </p>
                <Link to="/profile-setup" className="text-emerald-700 font-medium hover:text-emerald-800 transition duration-300" data-id="element-698">
                  Start Registration →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-699" />
    </div>;
};
export default Login;